import React from 'react'
import context from '@/context'
import { dialogTypes } from '@/dialogs'
import {
  createLookupFilterCell,
  LookupCell,
  Column,
  DateCell, DateFilterCell
} from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'

export const CapitalOperations = React.memo(function CapitalOperations ({ dataSource, readonly }) {
  const { localize } = useLocalization()
  return (
    <PropertyRenderer name='bankCapitalOperations' inputType='grid' dataSource={dataSource}
      readonly={readonly} addButtonLabel='Institutions.AddOperation'
      detailDialog={{ dialogType: dialogTypes.capitalOperation, loadData: context.api.bankService.getBankCapitalOperation }}>
      <Column field='bankCapitalOperationType' title={localize('Common.Type')}
        cell={LookupCell} filterCell={createLookupFilterCell(context.cache.getBankCapitalOperationTypes)} />
      <Column field='capitalizationAmount' title={localize('Institutions.CapitalizationAmount')} filter='numeric' />
      <Column field='underwritingAmount' title={localize('Institutions.UnderwritingAmount')} filter='numeric' />
      <Column field='participationAmount' title={localize('Institutions.ParticipationAmount')} filter='numeric' />
      <Column field='increaseAmount' title={localize('Institutions.IncreaseAmount')} filter='numeric' />
      <Column field='operationDate' title={localize('Institutions.OperationDate')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
    </PropertyRenderer>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/capitalOperations.js